module.exports = __webpack_public_path__ + "img/class.083f11e9.png";